/**
 * Admin authoring links in the fixed top bar (same row as settings + account).
 */
import React from 'react';
import { Button } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  displayPath,
  adminPath,
  reviewPath,
  contentSourcesPath,
  isAdminTopBarPath,
} from '../marketing/fusionMsiMarketingRouting';

export function showsDpTopBarAdminLinks(pathname) {
  return isAdminTopBarPath(pathname);
}

export default function DpTopBarAdminLinks() {
  const { pathname } = useLocation();

  if (!showsDpTopBarAdminLinks(pathname)) {
    return null;
  }

  return (
    <>
      <Button
        component={RouterLink}
        to={displayPath()}
        size="small"
        color="primary"
        sx={{ whiteSpace: 'nowrap' }}
      >
        DecisionPoint
      </Button>
      <Button
        component={RouterLink}
        to={contentSourcesPath()}
        size="small"
        sx={{ whiteSpace: 'nowrap' }}
      >
        Content sources
      </Button>
      <Button
        component={RouterLink}
        to={adminPath('library')}
        size="small"
        sx={{ whiteSpace: 'nowrap' }}
      >
        My library
      </Button>
      <Button
        component={RouterLink}
        to={adminPath('import')}
        size="small"
        sx={{ whiteSpace: 'nowrap' }}
      >
        Import source data
      </Button>
      <Button
        component={RouterLink}
        to={reviewPath()}
        size="small"
        sx={{ whiteSpace: 'nowrap' }}
      >
        Review inbox
      </Button>
    </>
  );
}
